module.exports = __webpack_public_path__ + "img/oauth2.5e1b0b3c.svg";